import { datadogRum } from '@datadog/browser-rum'

import { toast as rwToast } from '@redwoodjs/web/dist/toast'

import { isAuthRedirecting } from 'src/lib/authState'

export const toast = (text, variant = 'success', context = {}) => {
  // Suppress error toasts when the user is being redirected to logout
  // to prevent a flood of error messages from multiple failed requests
  if (variant === 'error' && isAuthRedirecting()) {
    return
  }

  if (variant === 'error') {
    const error = new Error(typeof text === 'string' ? text : 'Toast error')
    datadogRum.addError(error, {
      source: 'toast',
      ...context,
    })
  }
  rwToast.custom(() => <Toast text={text} variant={variant} />, {
    position: 'bottom-center',
  })
}

const Toast = ({ text, variant }) => {
  return (
    <div
      className={`flex min-w-[200px] max-w-[400px] items-center justify-center text-wrap rounded bg-opacity-50 px-3 py-2 text-sm font-semibold
          ${
            variant == 'success' &&
            'bg-doubleNickel-green-100 text-doubleNickel-success-600'
          }
          ${
            variant == 'warning' &&
            'bg-doubleNickel-warning-100 text-doubleNickel-warning-600'
          }
          ${
            variant == 'error' &&
            'bg-doubleNickel-error-100 text-doubleNickel-error-600'
          }
          `}
    >
      {text}
    </div>
  )
}

export default Toast
